import { render } from "./failureLog.vue?vue&type=template&id=2c2f86d8&scoped=true"
import script from "./failureLog.vue?vue&type=script&lang=js"
export * from "./failureLog.vue?vue&type=script&lang=js"

import "./failureLog.vue?vue&type=style&index=0&id=2c2f86d8&lang=scss&scoped=true"
import "./failureLog.vue?vue&type=style&index=1&id=2c2f86d8&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2f86d8"]])

export default __exports__